import type { VariantProps } from "class-variance-authority"

import { Badge, type badgeVariants } from "@/components/ui/badge"
import { cn } from "@/lib/utils"

type BadgeVariant = VariantProps<typeof badgeVariants>["variant"]

// IMP-403: account-state → distinct label + badge variant. Prospect (a shared
// landing-page shell the customer hasn't engaged with) reads as visually
// separate from Onboarding, Active, and Inactive.
const ACCOUNT_STATE_BADGE: Record<
  string,
  { label: string; variant: BadgeVariant }
> = {
  // IMP-509: an assessment demo account nobody has claimed yet — visible to
  // admins only; the partner portal filters these out entirely.
  provisional: { label: "Provisional", variant: "outline" },
  prospect: { label: "Prospect", variant: "info" },
  onboarding: { label: "Onboarding", variant: "warning" },
  active: { label: "Active", variant: "operational" },
  inactive: { label: "Inactive", variant: "draft" },
}

export function AccountStateBadge({
  state,
  className,
}: {
  state: string
  className?: string
}) {
  const badge = ACCOUNT_STATE_BADGE[state] ?? {
    label: state,
    variant: "outline" as BadgeVariant,
  }

  return (
    <Badge
      variant={badge.variant}
      className={cn("shrink-0 capitalize", className)}
    >
      {badge.label}
    </Badge>
  )
}
